'use client';

import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type InstallPromptCoordinationContextValue = {
  isPushPromptActive: boolean;
  isPwaPromptActive: boolean;
  setIsPushPromptActive: Dispatch<SetStateAction<boolean>>;
  setIsPwaPromptActive: Dispatch<SetStateAction<boolean>>;
};

const InstallPromptCoordinationContext = createContext<
  InstallPromptCoordinationContextValue | undefined
>(undefined);

export const InstallPromptCoordinationProvider = ({ children }: PropsWithChildren) => {
  const [isPwaPromptActive, setIsPwaPromptActive] = useState(false);
  const [isPushPromptActive, setIsPushPromptActive] = useState(false);

  const value = useMemo(
    () => ({
      isPushPromptActive,
      isPwaPromptActive,
      setIsPushPromptActive,
      setIsPwaPromptActive,
    }),
    [isPushPromptActive, isPwaPromptActive]
  );

  return (
    <InstallPromptCoordinationContext.Provider value={value}>
      {children}
    </InstallPromptCoordinationContext.Provider>
  );
};

export const useInstallPromptCoordination = () => {
  const value = useContext(InstallPromptCoordinationContext);

  if (!value) {
    throw new Error(
      `${useInstallPromptCoordination.name} must be used inside of ${InstallPromptCoordinationProvider.name}`
    );
  }

  return value;
};
